module.exports = __webpack_public_path__ + "img/_magic-dagger_.1face198.svg";